import { IoCheckmark, IoCheckmarkCircle } from 'react-icons/io5';

export const IconCheckmark = IoCheckmark;

export const IconCheckmarkCircle = IoCheckmarkCircle;
